/**
 * Reclamation scrip. The hub's money, printed by an authority that no longer exists and honoured
 * anyway, because everyone agreed to keep pretending at the same time.
 *
 * Deliberately not bottle caps: `luckyBottleCap` is already an accessory charm, and one object
 * cannot be both the currency and the joke about the currency.
 */

import type { CurrencyItem } from '@/sim/items/itemContract';

export const RECLAMATION_SCRIP = {
  id: 'reclamationScrip',
  kind: 'currency',
  label: 'Reclamation scrip',
  description: 'Redeemable at any Bureau window. The Bureau has no windows left.',
  rarity: 'common',
  weightKg: 0.002,
  stackLimit: 5000,
  equip: null,
  unitValue: 1,
} as const satisfies CurrencyItem;
